import Video, { LocalDataTrack, createLocalAudioTrack, createLocalVideoTrack } from 'twilio-video';
import { TwilioRoomEvents } from './constants';
import { addDebugListeners } from './debug';
import {
  setRoom,
  setConnectionStatus,
  ConnectionStatus,
  addListenersToRoom,
  setLocalAudioTrack,
  setLocalVideoTrack,
} from '../redux/reducers';

// redux is used for convenience only
// we could use React.Context, but then we have to make our
// own version of useSelector/Subscription from react-redux

export const createTracks = (video = 'enabled', audio = 'enabled', data = []) => async (
  dispatch
) => {
  const tracks = [];

  if (video) {
    const videoTrack = await createLocalVideoTrack({ name: `video` });
    if (video === 'disabled') {
      videoTrack.disable();
    }
    tracks.push(videoTrack);
    dispatch(setLocalVideoTrack(videoTrack));
  }

  if (audio) {
    const audioTrack = await createLocalAudioTrack({ name: `audio` });
    if (audio === 'disabled') {
      audioTrack.disable();
    }
    tracks.push(audioTrack);
    dispatch(setLocalAudioTrack(audioTrack));
  }

  for (const dataTrackName of data) {
    const track = new LocalDataTrack({ name: dataTrackName, reliable: true });
    tracks.push(track);
  }

  return tracks;
};

export const connectRoom = (roomName, tracks, accessToken, disconnectHandler) => async (
  dispatch
) => {
  console.log('Connecting to room', roomName);
  dispatch(setConnectionStatus(ConnectionStatus.CONNECTING));

  // connect
  const room = await Video.connect(accessToken, {
    name: roomName,
    tracks,
    automaticSubscription: false, //isInterpreterUser(userData),
    bandwidthProfile: {
      video: {
        mode: 'collaboration',
        trackSwitchOffMode: 'predicted',
      },
    },
  });
  console.log('Video - connected to the room', room);
  dispatch(setConnectionStatus(ConnectionStatus.CONNECTED));

  // store room
  dispatch(setRoom(room));

  room.on(TwilioRoomEvents.Disconnected, async (room, error) => {
    await disconnectHandler(room, error);
    dispatch(setConnectionStatus(ConnectionStatus.DISCONNECTED));
  });

  dispatch(addListenersToRoom(room));

  addDebugListeners(room);
  return room;
};

export const disconnectRoom = () => async (dispatch, getState) => {
  const { room, videoTrack, audioTrack } = getState().twilio;
  if (room) {
    try {
      videoTrack && videoTrack.stop();
      audioTrack && audioTrack.stop();

      const localTracks = room.localParticipant.tracks;
      room.localParticipant.unpublishTracks(Array.from(localTracks.values()).map((t) => t.track));

      for (const [, participant] of room.participants) {
        participant.removeAllListeners();
      }
    } catch (error) {
      // ignore error
    }

    try {
      room.disconnect();
    } catch (error) {
      // ignore error, room already disconnected
    }

    dispatch(setRoom(null));
  }
};

export const unpublishVideoTracks = () => (dispatch, getState) => {
  const { room } = getState().twilio;
  if (!room) {
    return;
  }

  for (const [, publication] of room.localParticipant.videoTracks) {
    if (publication.track) {
      publication.track.stop();
    }
    publication.unpublish();
  }
};

export const publishLocalVideoTrack = (cameraEnabled) => async (dispatch, getState) => {
  const { room } = getState().twilio;
  const videoTrack = await createLocalVideoTrack({ name: `video` });
  if (!cameraEnabled) {
    videoTrack.disable();
  }
  room.localParticipant.publishTrack(videoTrack);
  dispatch(setLocalVideoTrack(videoTrack));
};
